import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  ACCESS: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "ACCESS",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getSystemAccess.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getSystemAccess.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      ACCESS: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getSystemAccess.rejected, (state, action) => ({
      ...state,
      loading: false,
      ACCESS: [],
      totalCount: 0,
    }));
    // //add Access 
    builder.addCase(Act.AddSystemAccess.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(Act.AddSystemAccess.fulfilled, (state, { payload }) => (
      console.log(payload),
      { 
      ...state,
      loading: false,
    }));
    builder.addCase(Act.AddSystemAccess.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // edit access
    builder.addCase(Act.EditSystemAccess.pending, (start, action) => ({
        ...start,
        loading: true,
      }));
      builder.addCase(Act.EditSystemAccess.fulfilled, (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }));
      builder.addCase(Act.EditSystemAccess.rejected, (state, action) => ({
        ...state,
        loading: false,
      }));
    // delete access
    builder.addCase(Act.DeleteSystemAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      });
      builder.addCase(Act.DeleteSystemAccess.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      });
      builder.addCase(Act.DeleteSystemAccess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || action.error;
      });
  },
});

export default slice;
